<template>
  <v-dialog
    v-model='dialog'
    scrollable
    max-width='640'
  >
    <v-card>
      <v-system-bar height="48" dense
                    class="myCardTitleColor verlauf abstandunten04"
      >
        <v-spacer></v-spacer>
        <v-toolbar-title class="toolbarWhite">{{ 'TITLE_SEARCH_FILTER_ADMIN' | translate}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-system-bar>
      <v-layout row>
        <v-container>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            :label= "labelFilter"
            clearable
            item-key="index"
            single-line
            hide-details
          ></v-text-field>
        </v-container>
      </v-layout>
      <v-card-text style="height: 300px;">
        <v-tabs
        fixed-tabs
        v-model="tabModel"
        color="white"
        slider-color="grey"
        slot="extension"
      >
        <v-tab>
          {{ 'TAB_EASY' | translate}}
        </v-tab>
        <v-tab>
          {{ 'TAB_ADVANCED' | translate}}
        </v-tab>
        <v-tab>
          {{ 'TAB_ADMIN' | translate}}
        </v-tab>
      </v-tabs>
        <v-tabs-items v-model="tabModel">
          <v-tab-item>
            <br>
            <v-data-table
              :headers="headers"
              :items="config"
              :pagination.sync="pagination"
              :search="search"
              v-model="selected"
              hide-actions
              item-key="id"
              select-all
              height="inherit"
            >
              <template slot="items" slot-scope="props">
                <td>
                  <v-checkbox
                    v-model="props.selected"
                    primary
                    hide-details
                  ></v-checkbox>
                </td>
                <td class="text-xs-left">{{ props.item.text }}</td>
              </template>
            </v-data-table>
          </v-tab-item>

          <v-tab-item>
            <br>
            <v-data-table
              :headers="headersExt"
              :items="configExt"
              :pagination.sync="paginationExt"
              :search="search"
              v-model="selectedExt"
              hide-actions
              select-all
              height="inherit"
            >
              <template slot="items" slot-scope="props">
                <td>
                  <v-checkbox
                    v-model="props.selected"
                    primary
                    hide-details
                  ></v-checkbox>
                </td>
                <td class="text-xs-left" @click="props.selected = !props.selected">{{ typesDef[props.item.type] }}</td>
                <td class="text-xs-left" @click="props.selected = !props.selected">{{ props.item.name }}</td>
                <td class="text-xs-left" @click="props.selected = !props.selected">{{ unitsDef[props.item.unit] }}</td>
              </template>
            </v-data-table>
          </v-tab-item>

          <v-tab-item>
            <br>
            <v-layout row justify-space-around>
              <v-flex md6>
                <v-select v-model="searchConfig"
                          :items="mySearchConfigs"
                          item-text="text"
                          item-value="id"
                          :clearable="true"
                          :label="labelSearch"
                ></v-select>
              </v-flex>
              <v-flex md4>
                <v-layout row style="padding-top: 14px;" justify-space-around>
                  <v-icon large class='handpointer' :disabled="!searchConfig" color='blue' :title="textButtExport" :text="textButtExport" @click='exportFilter()'>archive</v-icon><br>
                  <v-icon large class='handpointer' :disabled="!searchConfig" color='red' :title="textButtRemove" :text="textButtRemove" @click='deleteFilter()'>delete</v-icon><br>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6 sm6 md6 class="text-xs-center text-sm-center text-md-center text-lg-center">
                <br>
              </v-flex>
            </v-layout>
            <v-layout row justify-center>
              <input
                type="file"
                style="display: none"
                ref="image"
                accept=".json"
                @change="onFilePicked"
              >
              <v-flex xs12 sm12 md12>
                <v-btn flat @click="pickFile" style="min-width: 100%">{{ 'BUTT_IMPORT' | translate}}</v-btn>
              </v-flex>
            </v-layout>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small
               color='primary'
               flat
               @click='submit'>
          {{ 'BUTT_OK' | translate}}
        </v-btn>
      </v-card-actions>
    </v-card>
    <!--
    <v-card>
      <v-spacer/>
      <v-toolbar-title><span class="headline"></span></v-toolbar-title>

      <v-card-title color='primary' style="padding-bottom: 0px;">
      </v-card-title>
      <v-content>
        <v-layout row>
          <v-container>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Filter"
            single-line
            hide-details
          ></v-text-field>
          </v-container>
        </v-layout>
        <v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small
                   color='primary'
                   flat
                   @click='submit'>
              {{ 'BUTT_OK' | translate}}
            </v-btn>
          </v-card-actions>
          <v-data-table
            :headers="headers"
            :items="config"
            :pagination.sync="pagination"
            :search="search"
            hide-actions
            height="inherit"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  v-model="props.item.isEnabled"
                  primary
                  hide-details
                ></v-checkbox>
              </td>
              <td class="text-xs-left">{{ props.item.text }}</td>
            </template>
          </v-data-table>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small
                   color='primary'
                   flat
                   @click='submit'>
              {{ 'BUTT_OK' | translate}}
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-content>
    </v-card>
    -->
  </v-dialog>
</template>

<script>
import Vue from 'vue'
import swal from 'sweetalert2/dist/sweetalert2.js'
var base64 = require('base-64')
export default {
  name: 'DialogSearchFields',
  props: ['config', 'configExt'],
  data () {
    return {
      fileName: '',
      labelFilter: Vue.i18n.translate('LABEL_FILTER'),
      fileNameUrl: '',
      toggleAll: false,
      search: '',
      mySearchConfigs: [],
      dialog: false,
      searchConfig: null,
      labelSearch: Vue.i18n.translate('TITLE_CONFIG_FILTERSETS'),
      tabModel: 0,
      selected: [],
      textButtExport: Vue.i18n.translate('BUTT_EXPORT'),
      textButtRemove: Vue.i18n.translate('BUTT_FILTERSET_DELETE'),
      selectedExt: [],
      typesDef: {
        '3': 'Strukturposition',
        '7': 'Kennzahl'
      },
      unitsDef: {
        '1': 'Prozent',
        '2': 'Absolut'
      },
      pagination: {
        rowsPerPage: 50000
      },
      paginationExt: {
        rowsPerPage: 50000
      },
      headers: [
        { text: Vue.i18n.translate('HEADERS_DIALOG_SEARCH_NAME'), value: 'text' }
      ],
      headersExt: [
        { text: Vue.i18n.translate('HEADERS_DIALOG_SEARCH_TYP'), value: 'type' },
        { text: Vue.i18n.translate('HEADERS_DIALOG_SEARCH_NAME'), value: 'name' },
        { text: Vue.i18n.translate('HEADERS_DIALOG_SEARCH_UNITY'), value: 'unit' }
      ],
      maskConfig: {
        leftCheckboxes: [],
        isDynamic: false,
        entries: [],
        rows: []
      }
    }
  },
  methods: {
    pickFile () {
      this.$refs.image.click()
    },
    deleteFilter () {
      Vue.prototype.$api.debug('deleteFilter', this.searchConfig)
      if (this.searchConfig) {
        var data = {
          'id': this.searchConfig
        }
        Vue.prototype.$api.deleteSearchFieldConfigurations(null, data, this.onFiltersetDeleted)
      }
    },
    onFiltersetDeleted (data) {
      Vue.prototype.$api.debug('onFiltersetDeleted')
      swal(Vue.i18n.translate('DIALOG_TEXT_SUCCESS_FILTER_SET_DELETED'))
      Vue.prototype.$api.getSearchFieldConfigurations(this.onGetSearchConfigurations)
    },
    onFilePicked (e) {
      var cmp = this
      const files = e.target.files
      if (files[0] !== undefined) {
        this.imageName = files[0].name
        if (this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        var fileName = files[0].name
        var index = fileName.indexOf('.json')
        if (index > -1) {
          index = fileName.indexOf('_')
          var hashValue = fileName.split('.')
          hashValue = hashValue[0].split('_')[1]
          if (index > -1) {
            const fr = new FileReader()
            fr.readAsDataURL(files[0])
            fr.addEventListener('load', () => {
              var data = fr.result
              data = data.substring('data:application/json;base64,'.length)
              data = base64.decode(data)
              data = JSON.parse(data)
              Vue.prototype.$api.importSearchFieldConfigurations(hashValue, data, cmp.onConfigImported)
            })
          }
        }
      } else {
        this.imageName = ''
        this.imageFile = ''
        this.imageUrl = ''
      }
    },
    onConfigImported (data) {
      Vue.prototype.$api.debug('onConfigImported')
      if (data.success) {
        swal(Vue.i18n.translate('DIALOG_TEXT_SUCCESS_IMPORT'))
      } else {
        swal(Vue.i18n.translate('DIALOG_TEXT_FAILED_IMPORT'))
      }
      Vue.prototype.$api.getSearchFieldConfigurations(this.onGetSearchConfigurations)
    },
    show () {
      this.updateSelection()
      Vue.prototype.$api.getSearchFieldConfigurations(this.onGetSearchConfigurations)
      this.dialog = true
    },
    onGetSearchConfigurations (data) {
      this.mySearchConfigs = data
    },
    onChangeFilterCheckbox (a, b, c) {
      Vue.prototype.$api.debug('onChangeFilterCheckbox', a, b, c)
      var f = null
      if (a.isEnabled) {
        if (a.field === 'balanceSumFromPercent') {
          f = this.getConfigByName('balanceSumFrom')
          if (f) {
            f.isEnabled = true
          }
        }
        if (a.field === 'balanceSumToPercent') {
          f = this.getConfigByName('balanceSumTo')
          if (f) {
            f.isEnabled = true
          }
        }
      }
    },
    updateSelection () {
      for (var index in this.config) {
        var entry = this.config[index]
        if (entry.isEnabled) {
          this.selected.push(entry)
        }
      }
    },
    exportFilter () {
      Vue.prototype.$api.debug('exportFilter')
      var arr = []
      arr.push(this.searchConfig)
      Vue.prototype.$api.exportSearchFieldConfigurations(arr)
    },
    doToggleAll (toggleAll) {
      Vue.prototype.$api.debug('toggleAll', toggleAll)
      for (var index in this.config) {
        var entry = this.config[index]
        entry.isEnabled = this.selected.indexOf(entry) > -1
        entry.isAbsolute = entry.unit === 2
        if (entry.isEnabled) {
        }
      }
      for (index in this.configExt) {
        entry = this.configExt[index]
        entry.isEnabled = this.selectedExt.indexOf(entry) > -1
        entry.isAbsolute = entry.unit === 2
        if (entry.isEnabled) {
        }
      }
    },
    submit () {
      Vue.prototype.$api.debug('submit do updateSearchMask ()')
      this.dialog = false
      this.doToggleAll()
      var cmp = this
      this.$nextTick(function () {
        Vue.prototype.$eventHub.$emit('onChangeSearchMask', cmp.config, cmp.configExt)
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/dialogs/DialogSearchFields.vue